import {
  Add,
  Cached,
  Close,
  EditOutlined,
  Save,
  Search,
} from "@mui/icons-material";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Tooltip,
  useTheme,
} from "@mui/material";
import { ReactNode } from "react";
import { useStyles } from "./styles";

export interface FlowHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  isEditable?: boolean;
  onEnterEditMode?: () => void;
  onCancelEditMode?: () => void;
  onSaveChanges?: () => void;
  onAdd?: () => void;
  onRefresh?: () => void;
  saveLabel?: string;
  savingChanges?: boolean;
  disableEditMode?: boolean;
  disableSave?: boolean;
  loading?: boolean;
  extraActions?: ReactNode;
  startContent?: ReactNode;
}

export default function FlowHeader(props: FlowHeaderProps) {
  const {
    search,
    onSearchChange,
    searchPlaceholder = "Pesquisar",
    isEditable = false,
    onEnterEditMode,
    onCancelEditMode,
    onSaveChanges,
    onAdd,
    savingChanges = false,
    disableEditMode = false,
    disableSave = false,
    extraActions,
    startContent,
    onRefresh,
    loading = false,
    saveLabel = "Salvar alterações",
  } = props;

  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box sx={styles.boxHeader}>
      {isEditable ? (
        <Box sx={styles.boxStartContent}>{startContent}</Box>
      ) : (
        <TextField
          size="small"
          sx={styles.searchInput}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          autoComplete="off"
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            },
          }}
          placeholder={searchPlaceholder}
        />
      )}

      <Box sx={styles.boxActions}>
        {extraActions}

        {isEditable ? (
          <>
            <Button
              onClick={onCancelEditMode}
              disabled={savingChanges}
              variant="text"
              startIcon={<Close />}
            >
              Voltar
            </Button>

            <Tooltip title="Salvar as alterações feitas na tabela">
              <span>
                <Button
                  onClick={onSaveChanges}
                  disabled={savingChanges || disableSave}
                  variant="contained"
                  startIcon={<Save />}
                >
                  {saveLabel}
                </Button>
              </span>
            </Tooltip>
          </>
        ) : (
          <>
            {onEnterEditMode && (
              <Tooltip title={"Edição em massa direto na tabela"}>
                <span>
                  <Button
                    onClick={onEnterEditMode}
                    disabled={disableEditMode}
                    variant="outlined"
                    startIcon={<EditOutlined />}
                  >
                    Modo edição
                  </Button>
                </span>
              </Tooltip>
            )}

            {onAdd && (
              <Button
                onClick={onAdd}
                disabled={loading}
                variant="contained"
                startIcon={<Add />}
              >
                Adicionar
              </Button>
            )}
            {onRefresh && (
              <Tooltip title={"Recarregar"}>
                <Button
                  size="small"
                  variant="contained"
                  disabled={loading}
                  onClick={() => onRefresh()}
                  sx={styles.buttonRefresh()}
                >
                  <Cached
                    fontSize="small"
                    className={loading ? "rotating" : ""}
                  />
                </Button>
              </Tooltip>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
